export default __webpack_public_path__ + "static/media/team5.6e54e5a0.jpg";